export class EksternBrugerPasswordResetTokenPublicModel {
    public resetTokenPublicId: string;
    public resetLinkErForældet: boolean;
    public resetLinkErBrugt: boolean;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/EksternBrugerPasswordResetTokenPublicModel.ts